module.exports = __webpack_public_path__ + "static/mundo-del-juguete-09575866bf1d69331bc7bd7eab7dd28d.jpg";